import { Module } from 'vuex';
import { PrivilegedIdSettingState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: PrivilegedIdSettingState = {
    privilegedIdSetting: undefined,
    show: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    update: {
        category: undefined,
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const privilegedIdSetting: Module<PrivilegedIdSettingState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
